import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IArticleCategory } from '~/api/article'

export default function useSeo(item?: IArticleCategory) {
  const globalStore = useGlobalStore()

  const title = `${item?.seo?.meta_title || item?.subject}｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = item?.seo?.meta_description || globalStore.seoDescriptions.sustainability
  const url = `${import.meta.env.VITE_DOMAIN}/sustainability/${item?.seo?.meta_slug || item?.id}`

  globalStore.setBreadcrumbs([
    { title: '永續生活', isActive: false, url: `/sustainability` },
    { title: item?.subject || '', isActive: true, url: url }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: item?.seo?.og_image?.link,
    keywords: item?.seo?.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '永續生活',
            item: `${import.meta.env.VITE_DOMAIN}/news`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: item?.subject,
            item: url
          }
        ]
      }
    ]
  })
}
